import { useState } from "react";

interface SwitchActivoProps<T> {
  id: number;
  isActivo: boolean;
  useUpdateHook: () => {
    mutate: (payload: T, options?: object) => void;
    isPending?: boolean;
  };
  getPayload: (newValue: boolean) => Partial<Omit<T, "id">>;
  onToggle?: (newValue: boolean) => void;
}

function SwitchActivo<T>({
  id,
  isActivo: initialActivo,
  useUpdateHook,
  getPayload,
  onToggle,
}: SwitchActivoProps<T>) {
  const [isActivo, setIsActivo] = useState(initialActivo);
  const { mutate, isPending } = useUpdateHook();

  const handleToggle = () => {
    const newValue = !isActivo;
    const payload = { id, ...getPayload(newValue) };
    mutate(payload as T, {
      onSuccess: () => {
        setIsActivo(newValue);
        if (onToggle) onToggle(newValue);
      },
      onError: () => {
        // Manejo de error (puedes mostrar notificación)
      },
    });
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      disabled={isPending}
      className={`px-3 py-1 rounded-full text-white text-xs font-bold transition-colors duration-200 ${
        isActivo
          ? "bg-green-500 hover:bg-green-600"
          : "bg-red-500 hover:bg-red-600"
      } ${isPending ? "opacity-50 cursor-not-allowed" : ""}`}
    >
      {isActivo ? "Activo" : "Inactivo"}
    </button>
  );
}

export default SwitchActivo;
